import { render } from "./UsersTab.vue?vue&type=template&id=25ac8469&scoped=true"
import script from "./UsersTab.vue?vue&type=script&lang=js"
export * from "./UsersTab.vue?vue&type=script&lang=js"

import "./UsersTab.vue?vue&type=style&index=0&id=25ac8469&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ac8469"]])

export default __exports__